import template from './charCountTextarea.html';
import controller from './charCountTextarea.controller';
import './charCountTextarea.scss';

let charCountTextareaComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    maxCount: '@',
    send: '&',
    message: '=',
    validation: '<'
  },
  template,
  controller
};

export default charCountTextareaComponent;
